import { CheckCircle2 } from "lucide-react";
import { whyUs, testimonial } from "../../mock";

export const WhyUs = () => (
  <section id="why-us" data-testid="why-us-section" className="py-24 md:py-32 bg-[#0B1035] border-y border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-4">Why Silent Sentry</p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white">
          An ally, not a vendor.
        </h2>
        <div className="mt-12 space-y-8">
          {whyUs.map((w) => (
            <div key={w.title} data-testid={`why-us-${w.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="flex gap-4">
              <CheckCircle2 className="w-6 h-6 text-cyan-400 shrink-0 mt-0.5" />
              <div>
                <h4 className="font-heading text-lg font-medium text-white">{w.title}</h4>
                <p className="mt-1 text-sm text-slate-400 leading-relaxed">{w.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col justify-center">
        <blockquote data-testid="testimonial-quote" className="border-l-2 border-violet-400 pl-8">
          <p className="font-heading text-2xl sm:text-3xl text-white leading-snug tracking-tight">
            “{testimonial.quote}”
          </p>
          <footer className="mt-8">
            <p className="text-white font-medium">{testimonial.name}</p>
            <p className="text-sm text-slate-400">{testimonial.role}</p>
          </footer>
        </blockquote>
      </div>
    </div>
  </section>
);
